import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "../../utils/axiosBaseQuery";

export const complaintsApi = createApi({
    reducerPath: 'complaintsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
    }),
    endpoints: (build) => ({
        getComplaints: build.query({
            query(params) {
                return {
                    url: `/admin/complaints`,
                    method: 'GET',
                    params: params
                }
            },
            providesTags: ['Complaints']
        }),
        getComplaintById: build.query({
            query(id) {
                return {
                    url: `/admin/complaints/${id}`,
                    method: 'GET',
                }
            },
            providesTags: ['Complaint'],
        }),
        replyToComplaint: build.mutation({
            query(data) {
                console.log({ data })
                return {
                    url: `/notifications/reply-complaint`,
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    },
                    method: 'POST',
                    data: data,
                    formData: true
                }
            },
            invalidatesTags: ['Complaints', 'Complaint', 'UnansweredComplaintsCount']
        }),
        getUnansweredComplaintsCount: build.query({
            query() {
                return {
                    url: `/admin/complaints/unanswered-count`,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response?.data?.total ?? 0,
            providesTags: ['UnansweredComplaintsCount']
        }),
        getComplaintTypes: build.query({
            query() {
                return {
                    url: `/complaint-types`
                }
            }
        })
        // getFilteredReceipts: build.query({
        //     query({ params }) {
        //         console.log({ params })
        //         const queryParams = new URLSearchParams(params).toString()
        //         return {
        //             url: `/receipts/filter?${queryParams}`,
        //             method: 'GET'
        //         }
        //     }
        // })
    }),
});

export const {
    useGetComplaintsQuery,
    useLazyGetComplaintsQuery,
    useReplyToComplaintMutation,
    useGetComplaintTypesQuery,
    useGetComplaintByIdQuery,
    useLazyGetComplaintByIdQuery,
    useGetUnansweredComplaintsCountQuery
} = complaintsApi;